// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_MANAGEMENT_NODE_BACKUP_LIST = 'management-node-backup/SET_MANAGEMENT_NODE_BACKUP_LIST';
export const ADD_MANAGEMENT_NODE_BACKUP_ITEM = 'management-node-backup/ADD_MANAGEMENT_NODE_BACKUP_ITEM';
export const UPDATE_MANAGEMENT_NODE_BACKUP = 'management-node-backup/UPDATE_MANAGEMENT_NODE_BACKUP';
export const UPDATE_MANAGEMENT_NODE_BACKUP_PROGRESS = 'management-node-backup/UPDATE_MANAGEMENT_NODE_BACKUP_PROGRESS';
export const SET_MANAGEMENT_NODE_BACKUP_IS_DELETING = 'management-node-backup/SET_MANAGEMENT_NODE_BACKUP_IS_DELETING';
export const SET_NEXT_SCHEDULED_MANAGEMENT_NODE_BACKUP_DATE = 'management-node-backup/SET_NEXT_SCHEDULED_MANAGEMENT_NODE_BACKUP_DATE';
